export default {
  message: {
    details: 'Details',
    back: 'Back',
    expected_name: 'Expected name',
    exportDataTitle: 'Download lists as Excel file',
    forename: 'First name',
    lastname: 'Last name',
    mobile_phone: '(MOBILE) phone',
    sales_representative: 'Sales representative',
    commitment_letter_accept: 'Commitment letter accept',
    iban_number: 'IBAN-nummer',
    without_supplier: 'Without supplier',
    price_in_euro: 'Price in Euro',
    supplier_price_in_euro: 'Original price of supplier: {0}',
    is_default: 'Default',
    fullUrl: 'Full URL',
    attribute_option: 'attribute option',
    image: 'Image',
    show_stats_user: 'Shop Statistics - USER',
    shopUserStats: {
      pageTitle: 'Shop Statistics - Users',
      viewList: 'View statistics',
      perPage: 'Rows per page',
      searchPlaceholder: 'Search by email, customer number, company…',
      paginationSummary: 'Showing {from}–{to} of {total} (page {page} / {lastPage})',
      loadError: 'Failed to load shop user statistics.',
      exporting: 'Exporting…',
      exportDone: 'Export completed ({rows} rows).',
      exportFailed: 'Export failed.',
      exportPanel: {
        title: 'Excel export',
        refreshStatus: 'Refresh status',
        lastExport: 'Last export',
        lastPoint: 'Last point',
        rowCount: 'Rows',
        stateReadyFresh: 'Data is up to date. You can download the export.',
        stateReadyStale:
          'Point import is newer than the last export. You can download the previous file or wait for the next cycle (every 15 min).',
        stateWaitingRefresh: 'Generating a new file…',
        stateNoFile: 'Export file is not available yet.',
        firstFileEta: 'First file expected around {eta}.',
        downloadExcel: 'Download Excel',
        formatLabel: 'Format',
        formatXlsx: 'XLSX (.xlsx)',
        formatXls: 'XLS (.xls)',
        downloadLastFile: 'Download last file',
        waitForUpdate: 'Wait for update',
        refreshInProgress: 'Update in progress…',
        downloadSuccess: 'File downloaded.',
        downloadUpdatedSuccess: 'Updated file downloaded.',
        downloadRunning: 'Update in progress, please try again shortly.',
        downloadNotReady: 'File not ready yet. Next attempt around {eta}.',
        waitTimeout: 'Timed out waiting for a new export.',
        statusLoadFailed: 'Failed to load export status.',
        staleConfirmTitle: 'Download older export file?',
        staleConfirmBody: 'The file is from {exportAt}, points were last updated at {pointAt}. Continue?'
      }
    },
    is_manual_order: 'Is manual order',
    supplier_id: 'Supplier ID',
    vendor_id: 'Manufacturer ID',
    archive_at: 'Archive',
    exported_bridgestone: 'Exported Bridgestone',
    exported_engelbert: 'Exported Engelbert Strauß',
    exported_prime: 'Exported prime',
    exported_other: 'Exported other',
    product_variant_id: 'Product variant id',
    cancelled_at: 'Cancelled at',
    shipped_at: 'Shipped at',
    product_id: 'Product id',
    quantity: 'Quantity',
    qty: 'Quantity',
    action_text: 'URL text',
    action_url: 'URL',
    token: 'UUID',
    marketing_option: 'Marketing option',
    parent_id: 'Parent ID',
    parent_name: 'Parent name',
    approval_id: 'Approval id',
    wholesaler_id: 'Wholesaler id',
    cart_id: 'Cart id',
    order_date: 'Order date',
    order_number: 'Order number',
    accept_date: 'Accept date',
    wholesaler_dealer_id: 'Wholesaler dealer id',
    dealer_id: 'Dealer id',
    is_partial_delivery: 'Is partial delivery',
    order_completed: 'Order completed',
    order_cancelled: 'Order cancelled',
    date_delivery: 'Delivery date',
    published: 'Publish',
    properties: 'Properties',
    group: 'Group name',
    gka: 'GKA',
    publish_at: 'Publish',
    video: 'Video url',
    training_id: 'Training ID',
    correct: 'Is correct?',
    question_id: 'Question ID',
    body: 'Content',
    size: 'Text size',
    platform: 'Operating system',
    is_added: 'Active Booster',
    numberOfSetsOfSeasonalTiresBudget: 'storage per year',
    distributionWinter: 'Winter',
    distributionSummer: 'Summer',
    overEighteenInch: 'Of which ≥ 18 inches (in %)',
    tireSalesNumber: 'Tire sales per year approx. in units.',
    distributionAll: 'All season',
    budgetPremium: 'Premium',
    postal_code: 'Postal code',
    legalForm: 'Legal form',
    budgetMid: 'Middle',
    budgetLow: 'Budget',
    group_id: 'Group ID',
    website: 'website',
    customer_number: 'Customer number',
    user_id: 'User ID',
    browser: 'web Browser',
    ip: 'Ip address',
    email_verified_at: 'email verified at',
    last_login: 'Last login',
    deleted_at: 'deleted at',
    is_active: 'Is active?',
    old: 'Old',
    selectBooster: 'Select booster',
    activeBooster: 'Active Booster',
    activeBoosterText: 'Do you want to active booster for user?',
    activeBoostersOne: 'Are you going to active this booster for every user?',
    activeBoostersSalesDataWarning:
      'Please make sure that the sales data you are about to boost are the final sales figures and will not be changed in the future. Otherwise, discrepancies in the calculations may occur. This action cannot be undone.',
    sum: 'Sum',
    boosterOnTop: 'Booster Points (on Top)',
    relevantBoosterPoints: 'Relevant booster points',
    totalBefore: 'Points Total Before',
    standardPoints: 'Standard points',
    standard: 'Standard',
    boosterPoints: 'Booster points',
    allPoints: 'All points',
    pointsByUser: 'Download points by user',
    pointsByGroup: 'Download points by group',
    allKickbacks: 'All kickbacks',
    kickbackByUser: 'Download kickback by user',
    kickbackByGroup: 'Download kickback by group',
    pointsImportFileInfo: 'In the file, column 1 must be email and column 2 points.',
    pointsImportHeaderInfo: 'The first row must contain the headers: Email and Points. Data should start from the second row.',
    pointsImportValueInfo:
      'Point values in the file must be positive or negative. Use positive values to add points and negative values to subtract points.',
    pointsImportTitle: 'Points import from Excel file',
    pointsImportFailed: 'Import failed',
    pointsImportSummaryTitle: 'Import summary',
    pointsImportProcessed: 'Processed',
    pointsImportInvalidFile: 'Only Excel files (.xlsx, .xls) are allowed.',
    pointsImportPreviewLoading: 'Preparing file preview...',
    pointsImportPreviewCount: 'Showing {shown} of {count} rows from the file.',
    pointsImportPreviewEmpty: 'The selected file does not contain any rows to import.',
    pointsImportPreviewError: 'Failed to read the selected Excel file.',
    pointsImportDateInfo:
      'The selected date will be used as the date when the points are created on the user account. These points may also refer to past periods.',
    loginAs: 'Login as user',
    positionX: 'Position x',
    positionY: 'Position y',
    textSize: 'Text size',
    text: 'Text',
    publish: 'Publish',
    certificate: 'Certificate',
    certificatePdf: {
      title: 'CERTIFICATE',
      tookPartInCourse: 'took part in course:',
      courseDetails: 'Course details'
    },
    remove_cs_number: 'Are you sure you want to delete customer number {customerNumber} ({wholesaler})?',
    keep_previous_year_points: 'Keep points from previous years after deleting the customer number',
    keep_previous_year_points_warning:
      'If you select this option, deleting the customer number will remove only points from the current year. Points from previous years will remain, so older balances and reports may still include data linked to this customer number. Select this only if you want to keep past years unchanged.',
    remove_order: 'Are you sure you want to delete the order?',
    is_internal: 'Is internal user?',
    selectAddressBtn: 'Select address',
    currentBasket: 'Current basket',
    loginEmail: 'Login',
    tenantEmailType: 'Email type',
    tenantEmailAddNew: 'Add new email',
    tenantEmailTypeFinancial: 'For financial information (e.g. bonus specification)',
    tenantEmailTypeMarketing: 'For Bridgestone Plus marketing communication (e.g. campaigns/newsletters)',
    open_new_tab: 'Open in new tab?',
    newTabLabel: 'New tab',
    file: 'File',
    company_name: 'Company name',
    partner_name: 'Contact person',
    boosterImport: {
      label: 'CSV/XLSX/XLS File.',
      name: 'Import name'
    },
    event: 'Event',
    created_at: 'Created at',
    done_by: 'Done By',
    modified_user: 'Affected User',
    modified_users: 'Affected Users',
    authors: 'Done by',
    changes: 'Changes',
    dealer: 'Dealer',
    dealers: 'Dealers',
    activity: 'Activity',
    logs: 'Logs',
    full_text_search: 'Full text search',
    booster_wholesaler: 'Wholesaler',
    booster_saison: 'Saison',
    booster_create: 'Create Booster',
    booster_brands: 'Brands',
    booster_motor: 'Motor',
    booster_message_title: 'Message title',
    booster_delete_points: 'Delete points',
    booster_delete_points_confirm: 'Are you sure you want to delete these booster points? This action cannot be undone.',
    booster_tires: 'Tires',
    booster_products: 'Product names',
    booster_customers: 'Customer numbers',
    booster_ipcs: 'IPCs',
    boosterIpcsImport: {
      button: 'Upload IPCs from Excel',
      hint: 'Column A, .xlsx/.xls file',
      emptySheet: 'Empty worksheet.',
      emptyColumn: 'No data in column A.',
      spacesError: 'Invalid IPCs (contains spaces): {items}',
      invalidFormatError: 'Invalid IPC format (numbers only): {items}',
      requestValidationError: 'Request validation error.',
      unknownError: 'Unknown IPCs: {items}',
      success: 'Imported IPCs: {count}',
      readError: 'Failed to read IPCs file.'
    },
    booking: 'Booking',
    booster_factor: 'Multiply',
    select: 'Please select',
    preview: 'Preview',
    credit: 'Credit',
    deduction: 'Deduction',
    subject: 'Subject',
    customerNumber: 'Customer number',
    search: 'Search',
    customer_nr_name: 'Customer number / name',
    selectAll: 'Select all',
    deselectAll: 'Deselect all',
    generateReport: {
      selectAll: 'Select all',
      reset: 'Reset',
      loadingInfo: 'Generating report, please wait...',
      generate: 'Generate',
      validation: {
        distributorRequired: 'Please select at least one distributor.'
      },
      personal_data: {
        title: 'Personal data',
        email: 'Email',
        salutation: 'Salutation',
        first_name: 'First name',
        last_name: 'Last name',
        job_position: 'Job position'
      },
      shipping_address: {
        title: 'Shipping address',
        company: 'Company',
        street: 'Street',
        postal_code: 'Postal code',
        mobile_phone: 'Mobile phone',
        iban_number: 'IBAN number',
        vat: 'VAT',
        city: 'City'
      },
      operating_data: {
        title: 'Operating data',
        customer_number: 'Customer number',
        group: 'Group',
        first_registration: 'First registration',
        last_login: 'Last login',
        tires_per_year: 'Tire sales per year',
        over_18_inch: 'Over 18 inch',
        premium: 'Premium',
        middle: 'Middle',
        summer: 'Summer',
        winter: 'Winter',
        all_season: 'All season',
        major: 'Major',
        customer_group: 'Customer group'
      },
      calculated_data: {
        title: 'Calculated data',
        tireAmount: 'Tire amount',
        points: 'Points',
        bonus: 'Bonus'
      },
      sales_structure: {
        title: 'Sales structure',
        distributor: {
          title: 'Distributor'
        },
        sales_representative: {
          title: 'Sales representative'
        },
        wholesaler: {
          title: 'Wholesaler'
        },
        dealer: {
          title: 'Dealer'
        }
      },
      meta: {
        title: 'Filters',
        brand: {
          title: 'Brand',
          BS: 'BS',
          FS: 'FS'
        },
        year: {
          title: 'Year'
        },
        calendarMonth: {
          title: 'Month',
          january: 'January',
          february: 'February',
          march: 'March',
          april: 'April',
          may: 'May',
          june: 'June',
          july: 'July',
          august: 'August',
          september: 'September',
          october: 'October',
          november: 'November',
          december: 'December'
        }
      }
    },
    import: 'Import',
    rows: 'Rows',
    message: 'Message',
    articleNumber: 'Article number',
    inform_user: 'To inform customers',
    leaveComment: 'Leave a comment here',
    user_new: 'New User',
    actions: 'Actions',
    residence: 'Is residence',
    emailVerified: 'E-Mail verified at',
    optinAt: 'OptIn at',
    registerAt: 'Register at',
    street: 'Street and number',
    country: 'Country',
    postalcode: 'Postcode',
    city: 'City',
    suffix: 'Address suffix',
    fax: 'Fax',
    date: 'Date',
    optinToken: 'OptIn-Token',
    title: 'Title',
    subtitle: 'Subtitle',
    phone: 'Phone',
    company: 'Company',
    language: 'Language',
    salutation: 'Salutation',
    userData: 'Userdata',
    clientType: 'Client type',
    carDealer: 'Car dealer',
    tyreDealer: 'Tyre dealer',
    teamLkw: 'Team LKW',
    teamEmOtr: 'Team EM/OTR',
    teamFarmTractor: 'Team agricultural tractor',
    teamBandag: 'Team retreading',
    chooseDots: 'Choose..',
    both: 'Both',
    contact_service: {
      is_main: 'Is main?',
      direct: 'Direct',
      indirect: 'Indirect'
    },
    fileChoose: 'Choose file',
    fileNoSelected: 'No file selected',
    loadingFile: 'Loading file...',
    only_points_payment: 'Only points payment',
    column: 'Column',
    csvOnly: 'Only CSV files are allowed.',
    milestoneUsers: {
      csvImportTitle: 'CSV import',
      csvFormatHint: 'CSV format: <code>email,milestone</code> (header optional)',
      importErrorsTitle: 'Import errors',
      errorLine: 'Line {line}: {message}',
      importFinished: 'CSV import finished.'
    },
    kickbackPayoutReady: 'Form ready to send. Selected file:',
    kickbackPayoutCsvInstruction: 'CSV file must contain two columns: first with email, second with bonus amount in EUR.',
    kickbackPayoutCsvHeaderInvalid:
      'Invalid CSV header. First column must be Email, second must be in format Bonus <number> (e.g. Bonus 25).',
    kickbackPayoutCsvTwoColumnsOnly: 'CSV must contain exactly two columns: Email and number.',
    kickbackPayoutCsvEmailNumberInvalid:
      'Invalid CSV data. First column must be an email address, second column must be a number.',
    kickbackPayoutCsvBonus: 'CSV bonus',
    kickbackPayoutKickBackFeeSum: 'Kick back fee sum',
    kickbackPayoutYear: 'Year',
    kickbackPayoutMissingEmails: 'Missing emails:',
    kickbackPayoutCsvFile: 'CSV',
    kickbackPayoutCsvContent: 'CSV content',
    kickbackPayoutAllTranslationsRaw: 'All translations (raw)',
    multiplicator: {
      goals: {
        loyal: 'Loyal',
        bronze: 'Bronze',
        silver: 'Silver',
        gold: 'Gold',
        platinum: 'Platinum'
      }
    },
    importSchemaNotLoaded: 'Import schema is not loaded.',
    csvHeaderEmpty: 'CSV header is empty.',
    csvHeaderMismatch: 'CSV header mismatch at column {index}: expected "{expected}", got "{actual}".',
    csvHeaderMismatchTitle: 'CSV header mismatch',
    csvColumnCountMismatchTitle: 'CSV column count mismatch',
    csvColumnCountMismatch: 'Row {row}: expected {expected} columns, got {actual}.',
    csvHeaderColumnCountMismatch: 'Header row: expected {expected} columns, got {actual}.',
    step: 'Step',
    profile: 'Profile',
    addresses: 'Adresses',
    address: 'Address',
    vendor_new: 'New vendor',
    supplier_new: 'New supplier',
    notAvailable: 'Currently not available at the time',
    disabled: 'Disabled',
    archived: 'Archived',
    visible_not_allowed_to_buy: 'Visible, Not Allowed to Buy',
    isDefault: 'Is Default?',
    data: 'Data',
    startImport: 'Start import',
    importText: 'Please select a file for import:',
    importSchemaInfo: 'The CSV file must contain the following fields in the exact order shown below.',
    importConfirm: 'Review the import preview below. Do you want to proceed with the import?',
    importWholesalerHint: 'Optional. When selected, customer numbers from the CSV will be assigned to this wholesaler.',
    importDownloadTemplate: 'Download empty CSV template',
    importModalTitle: 'Import users from CSV',
    importStepSetup: 'Setup',
    importStepPreview: 'Preview',
    importStepResult: 'Result',
    importStepHelper: 'Download the template, fill in your data, then upload the CSV file.',
    importContextTitle: 'Import settings',
    importRowsInFile: '{count} rows in file',
    importValidating: 'Validating file...',
    importPreviewLoading: 'Loading preview...',
    importSubmitting: 'Importing users...',
    importStatsSuccess: 'Success',
    importStatsError: 'Errors',
    importStatsInfo: 'Info',
    importStatsOther: 'Other',
    importShowSchema: 'Show column schema',
    importHideSchema: 'Hide column schema',
    importPreviewChangesCount: '{count} field changes',
    importDropzoneTitle: 'Drop CSV file here',
    importDropzoneHint: 'or click to choose a file',
    importSelectClientTypeForPreview: 'File looks valid ({count} rows). Select client type to load preview.',
    importFileValid: 'File validated successfully ({count} rows).',
    importLoadPreview: 'Load preview',
    importPreviewFilterErrors: 'Errors',
    importPreviewRowError: 'Error',
    importPreviewFailed: 'Failed to load import preview.',
    importPreviewSummary: 'Summary',
    importPreviewTotalRows: 'Total rows',
    importPreviewNewUsers: 'New users',
    importPreviewUpdatedUsers: 'Updated users',
    importPreviewSkippedRows: 'Skipped rows',
    importPreviewErrors: 'Errors',
    importPreviewNewCustomerGroups: 'New customer groups',
    importPreviewNewStaffUsers: 'New staff users',
    importPreviewAction: 'Action',
    importPreviewIncoming: 'Incoming',
    importPreviewCreates: 'Creates',
    importPreviewUpdates: 'Updates',
    importPreviewFieldChanges: 'Field changes',
    importPreviewFieldColumn: 'Field',
    importPreviewCurrentValue: 'Current',
    importPreviewFromFile: 'From file',
    importPreviewAfterImport: 'After import',
    importPreviewNewValue: 'New',
    importPreviewWillChange: 'Will change',
    importPreviewDiffersInFile: 'Differs in file',
    importPreviewOnlyWithChanges: 'Only rows with changes',
    importPreviewFilterAll: 'All rows',
    importPreviewShowDetails: 'Details',
    importPreviewBackToList: 'Back to list',
    importPreviewHideDetails: 'Hide details',
    importPreviewNoFilterResults: 'No rows match the selected filters.',
    importPreviewRowDetails: 'Row details',
    importPreviewPlannedChanges: 'Planned changes',
    importPreviewExistingData: 'Current data in system',
    importPreviewFullComparison: 'Full comparison',
    importPreviewNoExistingData: 'No existing data (new user).',
    importPreviewNoFieldDetails: 'No field details available for this row.',
    importPreviewCustomerGroups: 'Customer groups',
    importPreviewExistingCustomerGroups: 'Existing groups',
    importPreviewActionCreate: 'Create',
    importPreviewActionUpdate: 'Update',
    importPreviewActionUnchanged: 'Unchanged',
    importPreviewActionSkip: 'Skip',
    importPreviewNoCreates: 'Nothing new will be created',
    importPreviewNoUpdates: 'No fields will be updated',
    importPreviewNoRowDetails: 'Preview summary is available, but row details could not be loaded.',
    importPreviewDuplicateInFile: 'Duplicate in file',
    importSuccess: 'Import has been accomplished with success',
    importErrors: 'Import Errors',
    fileErrors: 'File Errors',
    normalizerErrors: 'Normalizer Errors',
    row: 'Row',
    rowData: 'Row Data',
    validationErrors: 'Validation Errors',
    importerErrors: 'Importer Errors',
    upload: 'Upload',
    vat: 'VAT',
    uploadText: 'Upload an image',
    users: 'Users',
    save: 'Save',
    saving: 'Saving...',
    downloadOrderStats: 'Download stats',
    downloadProductStats: "Download product's stats",
    category: 'Category',
    order: 'Order',
    permissions: 'Permissions',
    edit_permissions_title: 'Edit permissions',
    permission: 'Permission',
    options: 'Options',
    attributes: 'Attributes',
    add_attribute: 'Add Attribute',
    login: 'Log in',
    logout: 'Logout',
    email: 'E-Mail',
    username: 'Username',
    type: 'Type',
    status: 'State',
    filter: 'Filter',
    name: 'Name',
    remove: 'Remove',
    points: 'Points',
    description: 'Description',
    short_description: 'Short Description',
    count: 'count',
    action: 'Action',
    role: 'Role',
    sku: 'SKU',
    main: 'Main product',
    variant: 'product variant',
    active: 'Active',
    activeLabel: 'Active',
    vendor: 'Vendor',
    supplier: 'Supplier',
    images: 'Images',
    upload_text: 'Product-images upload',
    user: 'User',
    roles: 'Roles',
    search_products: 'Search products',
    search_orders: 'Search orders',
    search_type: 'Search type',
    hunter_new: 'New Hunter',
    first_name: 'First name',
    last_name: 'Last name',
    urssaf_address: 'Personal address required for URSSAF only',
    social_security_number: 'Social Security Number',
    place_of_birth: 'Place of Birth',
    date_of_birth: 'Date of Birth',
    copy: 'Copy',
    add_empty_variant: 'Add Empty Variant',
    activated: 'Activated',
    contacts: {
      empty: 'No contacts'
    },
    points_exporter_users_with_available_points: 'Users with Available Points',
    points_exporter_unlocked_points: 'Export of users with unlocked points',
    points_exporter_date_label: 'Date',
    start_date: 'Start date',
    end_date: 'End date',
    points_exporter_download_button: 'Download Excel',
    menu: {
      customerGroup: {
        new: 'New Customer Group',
        list: 'Customer Groups List'
      },
      shopLimits: 'Shop limits',
      default_banners: 'Default banners',
      import_adex: 'Adex import',
      adex: 'Adex',
      messages_new: 'New Message',
      messages_list: 'List',
      logs: 'Logs',
      activities: 'Activities',
      customer: 'Customer',
      booster_setup: 'Booster Setup',
      booster_list: 'List',
      booster: 'Booster',
      points: 'Point management',
      cheques: 'Bonus & Deduction',
      'users-roles': 'Roles & Users',
      roles: 'Roles',
      users: 'Users',
      users_list: 'Users List',
      milestone_users: 'Milestone users',
      shop_user_stats_list: 'Shop user statistics',
      users_deleted: 'Deleted Users',
      user_new: 'Add New User',
      perms: 'Permissions',
      'product-categories': 'Categories & Products',
      categories: 'Categories',
      categories_list: 'Categories List',
      category_new: 'Add New Category',
      orders: 'Orders',
      products: 'Products',
      products_list: 'Products List',
      product_new: 'Add New Single Product',
      product_new_variants: 'New Product with Variants',
      attributes: 'Attributes',
      attributes_list: 'Attributes List',
      attribute_new: 'Add New Attribute',
      options_list: 'Options List',
      options_new: 'Add New Option',
      options: 'Options',
      vendors: 'Vendors',
      vendors_list: 'Vendors List',
      vendor_new: 'Add New Vendor',
      suppliers: 'Suppliers',
      suppliers_list: 'Suppliers List',
      supplier_new: 'Add New Supplier',
      sliders: 'Sliders',
      sliders_list: 'Sliders List',
      slider_new: 'Add New Slider',
      featured: 'Featured Products',
      commands: 'Commands',
      command_ipc: 'IPC',
      command_users: 'Import User',
      'trainings-schulungen': 'Trainings & Lectures',
      trainings: 'Product Trainings',
      trainings_list: 'List',
      training_new: 'Add New',
      btrainings_list: 'List',
      btraining_new: 'Add New',
      btrainings: 'BS Trainings',
      management: 'Content Management',
      textpages: 'Text Pages',
      textpages_list: 'Text Pages List',
      text_page_new: 'Add new Text Page',
      marketing_consents: 'Marketing Consents',
      marketing_consents_list: 'List',
      marketing_consents_edit: 'Edit Marketing Consent',
      settings: 'Messages manager',
      messages: 'Messages',
      threads: 'Threads',
      requests: 'Users requests',
      product_trainings_request: 'Product training requests',
      bridgestone_courses_request: 'Bridgestone courses requests',
      external_trainings_request: 'External trainings requests',
      hunter_request: 'Hunter',
      investments_request: 'Investment support',
      news_feed: 'Newsfeed',
      news_feed_list: 'News List',
      news_feed_new: 'Add new News',
      salespromotions: 'Sales Promotions',
      imported_products: 'Imported products',
      ipcs_list: 'IPC list',
      hunter_list: 'Hunter List',
      hunters: 'Hunters',
      hunter_new: 'New Hunter',
      groups_list: 'Dealer Groups List',
      parent_attributes: 'Parent Attributes',
      groups: 'Dealer Groups',
      group_new: 'New Dealer Group',
      history: 'Login history',
      history_list: 'Login History',
      prices: 'Prices',
      prices_list: 'List',
      price_new: 'New price',
      price_categories: 'Price lists',
      price_categories_list: 'List',
      price_categories_new: 'New price list',
      inactive_users: 'Not activated users',
      booster_importer: 'Booster CCS importer',
      booster_importer_form: 'Form',
      booster_importer_list: 'List',
      indirect_not_approved_users: 'Not approved users',
      approve_indirect: 'Approve Indirect Users',
      customer_numbers_to_approve: 'No customer numbers',
      complaints_list: 'Complaints',
      orders_list: 'List',
      orders_new: 'New order',
      points_list: 'Points list',
      kickback_list: 'Kickback fee',
      kickback_payout: 'Kickback payout',
      booster_preview: 'Preview',
      frontend_menu: 'Frontend menu',
      frontend_menu_list: 'List',
      frontend_menu_new: 'New',
      'customer-groups': 'Customer Groups',
      'customer-groups-list': 'Customer Groups List',
      'customer-groups-new': 'New Customer Group',
      'products-categories': 'Products & categories',
      mediapages: 'Media Pages',
      mediapages_list: 'List',
      media_page_new: 'New',
      uberall_request: 'Uberall',
      history_hour: 'Login hours',
      wholesaler_management: 'Wholesaler management',
      in_active_cs_nr: 'Inactive numbers',
      mediapages_file_list: 'File list',
      vouchers: 'Vouchers',
      vouchers_list: 'List',
      vouchers_new: 'New',
      brochure_prices_list: 'Management',
      brochure_prices: 'Product brochures',
      brochure_prices_new: 'New',
      main_boxes: 'Teaser Boxes',
      main_boxes_list: 'List',
      main_box: 'Edit',
      main_boxes_new: 'New',
      'hello-customer-survey': 'Hello Customer Survey',
      surveys_list: 'Surveys List',
      survey_new: 'Add New Survey',
      apps: 'Apps',
      apps_list: 'List of Apps',
      dealer_apps: 'Dealer apps',
      app_new: 'New',
      about_list: 'List',
      about_new: 'New',
      about: 'About page',
      about_edit: 'Edit',
      contact_service_list: 'List',
      contact_service_new: 'New',
      contact_service: 'Contact service page',
      contact_service_edit: 'Edit',
      promotions_edit: 'Edit',
      promotions_new: 'New',
      promotions_list: 'List',
      promotions: 'Promotions',
      campaigns_edit: 'Edit',
      campaigns_new: 'New',
      campaigns_list: 'List',
      campaigns: 'Campaigns',
      brochure_price: 'Brochures and Price list',
      brochure_file_list: 'List',
      booster_ccs_importer: 'Booster CCS',
      points_exporter: 'Points Exporter',
      points_exporter_export: 'Export',
      customer_numbers_assistant: 'Customer numbers Assistant'
    },
    breadcrumb: {
      shopLimits: 'Shop limits',
      in_active_cs_nr: 'Inactive numbers',
      default_banners: 'Default banners',
      import_adex: 'Adex import',
      adex: 'Adex',
      activities: 'Activities',
      customer: 'Customer',
      booster_setup: 'Booster Setup',
      booster_list: 'List',
      booster: 'Booster',
      booster_edit: 'Edit',
      cheques: 'Cheques & Deductions',
      user_edit: 'Edit user',
      user_new: 'New User',
      vendors: 'Vendors',
      suppliers: 'Suppliers',
      users: 'Users',
      user: 'User',
      home: 'Home',
      perms: 'Permissions',
      roles: 'Roles',
      roles_list: 'List',
      dashboard: 'Dashboard',
      orders: 'Orders',
      orders_edit: 'Edit Order',
      orders_view: 'Order',
      orders_list: 'Orders',
      salespromotions: 'Sales promotion',
      promotions: 'Promotions',
      promotions_list: 'List',
      promotions_new: 'New',
      salespromotions_list: 'List',
      salespromotions_view: 'View',
      'products-categories': 'Bonus Shop',
      'customer-groups': 'Customer Groups',
      'customer-groups-new': 'New Customer Group',
      'customer-groups-edit': 'Edit Customer Group',
      'customer-groups-list': 'Customer Groups List',
      customer_group_new: 'New Customer Group',
      categories: 'Categories',
      categories_list: 'List',
      role: 'Role',
      history: 'Login history',
      category: 'Category',
      products: 'Products',
      marketing_consents: 'Marketing Consents',
      marketing_consents_list: 'Marketing Consents List',
      marketing_consents_edit: 'Edit Marketing Consent',
      products_list: 'List',
      product: 'Product',
      product_new: 'New Single Product',
      product_new_variants: 'New Product with Variants',
      product_variants: 'Product with Variants',
      product_category: 'Category-Products',
      attributes: 'Attributes',
      attributes_list: 'List',
      attribute: 'Attribute',
      category_new: 'New Category',
      attribute_edit: 'Edit Attribute',
      options_new: 'New Option',
      options: 'Options',
      options_list: 'List',
      userEdit: 'Edit user',
      users_list: 'List',
      milestone_users: 'Milestone users',
      shop_user_stats_list: 'Shop user statistics',
      users_deleted: 'Deleted users',
      vendor_new: 'New Vendor',
      vendors_list: 'List',
      vendor_edit: 'Edit Vendor',
      supplier_new: 'New Supplier',
      suppliers_list: 'List',
      supplier_edit: 'Edit Supplier',
      trainings: 'Trainings',
      trainings_list: 'List',
      btrainings: 'Online-Trainings',
      btrainings_list: 'List',
      btraining: 'BS Training',
      training_new: 'New Training',
      btraining_new: 'New BS Training',
      training_edit: 'Edit Training',
      training: 'Training',
      command_ipc: 'IPC',
      sliders: 'Sliders',
      sliders_list: 'List',
      slider_new: 'New slider',
      slider: 'Edit slider',
      command_users: 'Import Users',
      textpages: 'Text pages',
      text_page_new: 'New Text page',
      textpage: 'Text page',
      textpages_list: 'List',
      messages: 'Messages',
      messages_list: 'List',
      messages_new: 'New Message',
      messages_edit: 'Edit message',
      threads: 'Threads',
      featured: 'Featured Products',
      attribute_new: 'New Attribute',
      product_trainings_request: 'Product trainings requests',
      bridgestone_courses_request: 'BS Training requests',
      external_trainings_request: 'External trainings requests',
      hunter_request: 'Hunter',
      investments_request: 'Investitionsunterstützung',
      news_feed: 'News feed',
      news_feed_list: 'Liste',
      news_feed_new: 'New News feed',
      news_feed_edit: 'Edit news feed',
      news_feed_slider: "New news feed's slider",
      content: 'Content',
      imported_products: 'Imported products',
      ipcs_list: 'IPC list',
      hunter_list: 'List',
      hunters: 'Hunters',
      hunter_new: 'New Hunter',
      hunter_edit: 'Edit Hunter',
      groups: 'Groups',
      groups_list: 'Groups List',
      parent_attributes: 'Parent Attributes',
      group_new: 'New Dealer Group',
      group_edit: 'Edit Dealer Group',
      history_list: 'Login history',
      history_view: 'User login history',
      prices: 'Prices',
      prices_list: 'List',
      price_new: 'New Price',
      price: 'Edit price',
      price_categories: 'Price lists',
      price_categories_list: 'List',
      price_categories_new: 'New price list',
      price_category: 'Price list',
      inactive_users: 'Not activated users',
      approve_indirect: 'Approve Indirect Users',
      inactive_users_list: 'List',
      customer_numbers_to_approve: 'No Customer numbers',
      complaints: 'Complaints',
      complaints_list: 'List',
      complaints_view: 'Complaint',
      orders_new: 'New order',
      points_list: 'Points list',
      kickback_list: 'Kickback fee',
      booster_preview: 'Preview',
      frontend_menu: 'Frontend menu',
      frontend_menu_list: 'List',
      frontend_menu_new: 'New',
      kickback_payout: 'Kickback payout',
      mediapages: 'Media Pages',
      mediapages_list: 'List',
      media_page_new: 'New',
      mediapage: 'Edit',
      uberall_request: 'Uberall',
      history_hour: 'Login hours',
      wholesaler_management: 'Wholesaler management',
      mediapages_file_list: 'File list',
      vouchers: 'Vouchers',
      vouchers_list: 'List',
      vouchers_new: 'New',
      brochure_prices_list: 'List',
      brochure_prices: 'Product brochures',
      brochure_prices_new: 'New',
      main_boxes: 'Teaser Boxes',
      main_boxes_list: 'List',
      main_box: 'Edit',
      main_boxes_new: 'New',
      'hello-customer-survey': 'Hello Customer Survey',
      surveys_list: 'Surveys List',
      survey_new: 'Add New Survey',
      survey: 'Survey',
      apps: 'Apps',
      apps_list: 'List of Apps',
      app_new: 'New',
      about: 'About page',
      about_list: 'List',
      about_new: 'New',
      app: 'Edit',
      about_edit: 'Edit',
      contact_service_list: 'List',
      contact_service_new: 'New',
      contact_service: 'Contact service page',
      contact_service_edit: 'Edit',
      promotions_edit: 'Edit',
      promotions_new: 'New',
      promotions_list: 'List',
      promotions: 'Promotions',
      campaigns_edit: 'Edit',
      campaigns_new: 'New',
      campaigns_list: 'List',
      campaigns: 'Campaigns',
      brochure_price: 'Brochures and Price list',
      brochure_file_list: 'List',
      booster_importer: 'Booster CCS importer',
      booster_importer_form: 'Form',
      booster_ccs_importer: 'Booster CCS',
      booster_importer_list: 'List',
      booster_edit: 'Edit',
      contact_service_description_list: 'Contact Service Description List',
      contact_service_description_edit: 'Edit Contact Service Description',
      contact_service_description_new: 'New Contact Service Description',
      points_exporter: 'Points Exporter',
      points_exporter_export: 'Export',
      customer_numbers_assistant: 'Customer numbers Assistant'
    },
    orders: {
      view: 'Order',
      new: 'New Order',
      list: 'Orders',
      edit: 'Edit Order',
      number: 'Order ID',
      date: 'Order Date',
      state: 'Order State',
      labels: {
        company: 'Company',
        name: 'Name',
        street: 'Street',
        postalCodeCity: 'Postal code / City',
        userPhone: 'User phone',
        userEmail: 'User email',
        orderPhone: 'Order phone'
      },
      status: {
        created: 'Created',
        confirm_order: 'Confirm order',
        ready_for_shipment: 'Ready for shipment',
        rejected: 'Rejected',
        processed: 'Processed',
        shipped: 'Shipped',
        returned: 'Returned',
        finished: 'Finished',
        deleted: 'Deleted'
      },
      cartQuantityIncreased: 'Product quantity increased in the cart.',
      cartQuantityDecreased: 'Product quantity decreased in the cart.',
      confirmIncreaseItem: 'Are you sure you want to increase the quantity of this product in the order?',
      confirmDecreaseItem: 'Are you sure you want to decrease the quantity of this product in the order?',
      confirmDeleteItem: 'Are you sure you want to remove this product from the order?',
      deletedInfo: 'This order was deleted on {date}',
      activityLogs: 'Change history',
      quantityChanged: 'Quantity: {from} → {to}',
      itemRemoved: 'Cannot be delivered / removed'
    },
    salespromotions: {
      view: 'Sales Promotion',
      list: 'Sales Promotions',
      premium: 'DRIVEOURBEST',
      guarantee: 'TYREPROTECT',
      bonusCampaign: 'REIFENHITS',
      advantage: 'VORTEILSAKTION'
    },
    countries: {
      ad: 'Andorra',
      ae: 'United Arab Emirates',
      af: 'Afghanistan',
      ag: 'Antigua & Barbuda',
      ai: 'Anguilla',
      al: 'Albania',
      am: 'Armenia',
      ao: 'Angola',
      aq: 'Antarctica',
      ar: 'Argentina',
      as: 'American Samoa',
      at: 'Austria',
      au: 'Australia',
      aw: 'Aruba',
      ax: 'Åland Islands',
      az: 'Azerbaijan',
      ba: 'Bosnia & Herzegovina',
      bb: 'Barbados',
      bd: 'Bangladesh',
      be: 'Belgium',
      bf: 'Burkina Faso',
      bg: 'Bulgaria',
      bh: 'Bahrain',
      bi: 'Burundi',
      bj: 'Benin',
      bl: 'St. Barthélemy',
      bm: 'Bermuda',
      bn: 'Brunei',
      bo: 'Bolivia',
      bq: 'Caribbean Netherlands',
      br: 'Brazil',
      bs: 'Bahamas',
      bt: 'Bhutan',
      bv: 'Bouvet Island',
      bw: 'Botswana',
      by: 'Belarus',
      bz: 'Belize',
      ca: 'Canada',
      cc: 'Cocos (Keeling) Islands',
      cd: 'Congo - Kinshasa',
      cf: 'Central African Republic',
      cg: 'Congo - Brazzaville',
      ch: 'Switzerland',
      ci: 'Côte d’Ivoire',
      ck: 'Cook Islands',
      cl: 'Chile',
      cm: 'Cameroon',
      cn: 'China',
      co: 'Colombia',
      cr: 'Costa Rica',
      cu: 'Cuba',
      cv: 'Cape Verde',
      cw: 'Curaçao',
      cx: 'Christmas Island',
      cy: 'Cyprus',
      cz: 'Czechia',
      de: 'Germany',
      dj: 'Djibouti',
      dk: 'Denmark',
      dm: 'Dominica',
      do: 'Dominican Republic',
      dz: 'Algeria',
      ec: 'Ecuador',
      ee: 'Estonia',
      eg: 'Egypt',
      eh: 'Western Sahara',
      er: 'Eritrea',
      es: 'Spain',
      et: 'Ethiopia',
      fi: 'Finland',
      fj: 'Fiji',
      fk: 'Falkland Islands',
      fm: 'Micronesia',
      fo: 'Faroe Islands',
      fr: 'France',
      ga: 'Gabon',
      gb: 'United Kingdom',
      gd: 'Grenada',
      ge: 'Georgia',
      gf: 'French Guiana',
      gg: 'Guernsey',
      gh: 'Ghana',
      gi: 'Gibraltar',
      gl: 'Greenland',
      gm: 'Gambia',
      gn: 'Guinea',
      gp: 'Guadeloupe',
      gq: 'Equatorial Guinea',
      gr: 'Greece',
      gs: 'South Georgia & South Sandwich Islands',
      gt: 'Guatemala',
      gu: 'Guam',
      gw: 'Guinea-Bissau',
      gy: 'Guyana',
      hk: 'Hong Kong SAR China',
      hm: 'Heard & McDonald Islands',
      hn: 'Honduras',
      hr: 'Croatia',
      ht: 'Haiti',
      hu: 'Hungary',
      id: 'Indonesia',
      ie: 'Ireland',
      il: 'Israel',
      im: 'Isle of Man',
      in: 'India',
      io: 'British Indian Ocean Territory',
      iq: 'Iraq',
      ir: 'Iran',
      is: 'Iceland',
      it: 'Italy',
      je: 'Jersey',
      jm: 'Jamaica',
      jo: 'Jordan',
      jp: 'Japan',
      ke: 'Kenya',
      kg: 'Kyrgyzstan',
      kh: 'Cambodia',
      ki: 'Kiribati',
      km: 'Comoros',
      kn: 'St. Kitts & Nevis',
      kp: 'North Korea',
      kr: 'South Korea',
      kw: 'Kuwait',
      ky: 'Cayman Islands',
      kz: 'Kazakhstan',
      la: 'Laos',
      lb: 'Lebanon',
      lc: 'St. Lucia',
      li: 'Liechtenstein',
      lk: 'Sri Lanka',
      lr: 'Liberia',
      ls: 'Lesotho',
      lt: 'Lithuania',
      lu: 'Luxembourg',
      lv: 'Latvia',
      ly: 'Libya',
      ma: 'Morocco',
      mc: 'Monaco',
      md: 'Moldova',
      me: 'Montenegro',
      mf: 'St. Martin',
      mg: 'Madagascar',
      mh: 'Marshall Islands',
      mk: 'North Macedonia',
      ml: 'Mali',
      mm: 'Myanmar (Burma)',
      mn: 'Mongolia',
      mo: 'Macao SAR China',
      mp: 'Northern Mariana Islands',
      mq: 'Martinique',
      mr: 'Mauritania',
      ms: 'Montserrat',
      mt: 'Malta',
      mu: 'Mauritius',
      mv: 'Maldives',
      mw: 'Malawi',
      mx: 'Mexico',
      my: 'Malaysia',
      mz: 'Mozambique',
      na: 'Namibia',
      nc: 'New Caledonia',
      ne: 'Niger',
      nf: 'Norfolk Island',
      ng: 'Nigeria',
      ni: 'Nicaragua',
      nl: 'Netherlands',
      no: 'Norway',
      np: 'Nepal',
      nr: 'Nauru',
      nu: 'Niue',
      nz: 'New Zealand',
      om: 'Oman',
      pa: 'Panama',
      pe: 'Peru',
      pf: 'French Polynesia',
      pg: 'Papua New Guinea',
      ph: 'Philippines',
      pk: 'Pakistan',
      pl: 'Poland',
      pm: 'St. Pierre & Miquelon',
      pn: 'Pitcairn Islands',
      pr: 'Puerto Rico',
      ps: 'Palestinian Territories',
      pt: 'Portugal',
      pw: 'Palau',
      py: 'Paraguay',
      qa: 'Qatar',
      re: 'Réunion',
      ro: 'Romania',
      rs: 'Serbia',
      ru: 'Russia',
      rw: 'Rwanda',
      sa: 'Saudi Arabia',
      sb: 'Solomon Islands',
      sc: 'Seychelles',
      sd: 'Sudan',
      se: 'Sweden',
      sg: 'Singapore',
      sh: 'St. Helena',
      si: 'Slovenia',
      sj: 'Svalbard & Jan Mayen',
      sk: 'Slovakia',
      sl: 'Sierra Leone',
      sm: 'San Marino',
      sn: 'Senegal',
      so: 'Somalia',
      sr: 'Suriname',
      ss: 'South Sudan',
      st: 'São Tomé & Príncipe',
      sv: 'El Salvador',
      sx: 'Sint Maarten',
      sy: 'Syria',
      sz: 'Eswatini',
      tc: 'Turks & Caicos Islands',
      td: 'Chad',
      tf: 'French Southern Territories',
      tg: 'Togo',
      th: 'Thailand',
      tj: 'Tajikistan',
      tk: 'Tokelau',
      tl: 'Timor-Leste',
      tm: 'Turkmenistan',
      tn: 'Tunisia',
      to: 'Tonga',
      tr: 'Türkiye',
      tt: 'Trinidad & Tobago',
      tv: 'Tuvalu',
      tw: 'Taiwan',
      tz: 'Tanzania',
      ua: 'Ukraine',
      ug: 'Uganda',
      uk: 'United Kingdom',
      um: 'U.S. Outlying Islands',
      us: 'United States',
      uy: 'Uruguay',
      uz: 'Uzbekistan',
      va: 'Vatican City',
      vc: 'St. Vincent & Grenadines',
      ve: 'Venezuela',
      vg: 'British Virgin Islands',
      vi: 'U.S. Virgin Islands',
      vn: 'Vietnam',
      vu: 'Vanuatu',
      wf: 'Wallis & Futuna',
      ws: 'Samoa',
      xk: 'Kosovo',
      ye: 'Yemen',
      yt: 'Mayotte',
      za: 'South Africa',
      zm: 'Zambia',
      zw: 'Zimbabwe'
    },
    messages: {
      list: 'Messages',
      new: 'New Message',
      edit: 'Edit Message',
      title: 'Title',
      fullUrl: 'fullUrl',
      content: 'Content',
      empty: 'No messages',
      direct: 'Direct message',
      toDealers: 'To Dealers',
      sendEmail: 'Send email',
      selectWholesalers: 'Select wholesalers',
      directWholesaler: 'From wholesalers to dealers',
      selectGroups: 'Select groups',
      directGroup: 'To dealer groups',
      toGroups: 'To Groups',
      saveAndSend: 'Save and send',
      users: 'Select users (min. 3 characters)',
      sent: 'Sent',
      sendConfirm: {
        title: 'Send message',
        desc: 'Are you sure you want to send this message?',
        recipients: 'Recipients'
      },
      externalTrainingPoints: 'External Training / Investment Points',
      externalTrainingBank: 'External Training / Investment Account Owner',
      externalTrainingIBAN: 'External Training / Investment IBAN',
      onlineTrainingTitle: 'Product Training - Title',
      onlineTrainingPoints: 'Online Training - Points',
      hunterTitle: 'Hunter - Title',
      hunterPoints: 'Hunter - Points',
      hunterPrice: 'Hunter - Price',
      bTrainingTitle: 'BS Training - Title',
      bTrainingPoints: 'BS v - Points',
      pointsProfileComplete: 'Points - Profile Completed',
      orderProducts: 'Products in the order'
    },
    messages_alert: {
      title: 'Delete Message',
      desc: 'Do you really want to delete the message?'
    },
    groups_alert: {
      title: 'Delete Group',
      desc: 'Do you really want to delete the group?'
    },
    vendors_alert: {
      title: 'Delete Manufacturer',
      desc: 'Do you really want to delete the manufacturer?'
    },
    suppliers_alert: {
      title: 'Delete Supplier',
      desc: 'Do you really want to delete the supplier?'
    },
    threads: {
      title: 'Threads',
      choose: 'Please choose message',
      order: 'Choose thread for orders',
      salespromotions: 'Choose thread for sales promotions',
      externalTraining: 'Choose thread for external trainings',
      investment: 'Choose thread for investment',
      onlineTraining: 'Choose thread for product training',
      bTraining: 'Choose thread for BS Training',
      profileComplete: 'Choose thread for Profile complete',
      activeUser: 'Active user message'
    },
    userGroup: {
      parentAttributeName: 'Parent Attribute',
      name: 'Dealer Group name',
      gka: 'GKA',
      isMain: 'Is parent?',
      dealersGroupTab: 'Dealer Group',
      dealersTab: 'Dealers',
      searchDealers: 'Search dealers'
    },
    customerGroup: {
      name: 'Customer Group Name'
    },
    categories: 'Categories',
    count_users: 'Count users',
    count_perms: 'Count permissions',
    count_products: 'Count products',
    count_files: 'Files',
    count_options: 'Count Options',
    product: 'Product',
    attribute_new: 'New Attribute',
    product_new: 'New Single Product',
    product_new_variants: 'New Product with Variants',
    training_new: 'New Training',
    btraining_new: 'New BS Training',
    category_new: 'New Category',
    category_title: 'Category Title',
    category_desc: 'Category Description',
    category_image: 'Category Image',
    category_link: 'Category Link',
    category_alert: {
      title: 'Delete Category',
      desc: 'Do you really want to delete the category?'
    },
    text_page_alert: {
      title: 'Delete Text Page',
      desc: 'Do you really want to delete the text page?'
    },
    news_feed_alert: {
      title: 'Delete News Feed',
      desc: 'Do you really want to delete the news feed "{title}"?'
    },
    newsFeedList: {
      perPage: 'Items per page',
      loading: 'Loading news feeds…',
      paginationSummary: 'Showing {from}–{to} of {total} (page {page} / {lastPage})',
      moveUp: 'Move up',
      moveDown: 'Move down'
    },
    ipcList: {
      title: 'IPC list',
      perPage: 'Rows per page',
      clearFilters: 'Clear filters',
      loading: 'Loading IPCs…',
      accessDenied: 'You do not have permission to view the IPC list.',
      paginationSummary: 'Showing {from}–{to} of {total}',
      columns: {
        material: 'Material / IPC',
        detailed_brand: 'Detailed brand',
        tyre_size_designation: 'Tyre size',
        new_budget_category: 'Budget category',
        service_description: 'Service description',
        rim: 'Rim',
        marketing_product_brand: 'Marketing brand',
        marketing_product_name: 'Marketing name'
      }
    },
    slider_alert: {
      title: 'Delete Slider',
      desc: 'Do you really want to delete the slider "{title}"?'
    },
    question_alert: {
      title: 'Delete Question',
      desc: 'Do you really want to delete the question?'
    },
    certificate_alert: {
      title: 'Delete Certificate Text',
      desc: 'Do you really want to delete the certificate text?'
    },
    product_alert: {
      title: 'Delete Product',
      desc: 'Do you really want to delete the product?'
    },
    survey_alert: {
      title: 'Delete Survey',
      desc: 'Do you really want to delete the survey?'
    },
    cancel: 'Cancel',
    confirm: 'Confirm',
    training_edit: 'Edit Training',
    options_new: 'New Option',
    options_edit: 'Edit Option',
    subcategory: 'Subcategory',
    importStarted: 'Import was started',
    connection: 'Connection',
    variants: 'Variants',
    add_variant: 'Add Variant',
    vendors: 'Vendors',
    suppliers: 'Vendors',
    training: 'Training',
    commands: {
      ipc: 'IPC-Importer',
      users: 'Users Importer',
      boosterImporter: 'Booster Importer'
    },
    userImport: {
      label: 'XLSX type only'
    },
    questions: 'Questions',
    correctAnswer: 'Correct answer',
    validation: {
      required: 'Field is required'
    },
    edit_question: 'Edit questions',
    edit_btraining_Detail: 'Edit BS Training detail',
    video_url: 'Video url',
    save_new_question: 'Save new question',
    reward: 'Reward image - not required',
    poster: 'Poster image',
    sliderImageValidation: 'Image must be 1600x1040 px or 2x/3x/4x of this size.',
    mainBoxImageValidation: 'Image must be 368x150 px or 2x/3x/4x of this size.',
    imageDimensions: 'Image dimensions',
    season: 'Season',
    answers: 'Answers',
    training_details: 'Training details',
    extras: 'Additional information',
    duration: 'Duration',
    price: 'Price',
    min_participant: 'Minimum participants',
    max_participant: 'Maximum participants',
    choose_trainingType: 'Choose training type',
    update: 'Update',
    cost_type: 'Cost type',
    save_detail: 'Save detail',
    slider_new: 'New slider',
    sliders: 'Sliders',
    groups: 'Group',
    clientType: 'Client Type',
    slider: 'Edit slider',
    choose_showHideText: 'Show/hide text',
    text_page_new: 'New Text page',
    text_pages: 'Text pages',
    text_page: 'Text page',
    featured: {
      title: 'Featured Products',
      bestseller: 'Best sold',
      seasonal: 'Seasonal',
      affordable: 'Affordable',
      autoBestsellers: 'Show auto calculated bestsellers',
      affordableOffsetLabel: 'Max price offset',
      affordableLimitLabel: 'Display products limit'
    },
    seasons: {
      all: 'All Season',
      summer: 'Summer',
      winter: 'Winter',
      general: 'General'
    },
    addAddress: 'Add adress',
    administration: 'Administration',
    password: 'Password',
    forcedPasswordChange: {
      title: 'Change your password',
      description: 'Your temporary password must be changed before you can access the application.',
      enterNewPassword: 'Enter new password',
      repeatNewPassword: 'Repeat new password',
      strengthLabel: 'Password strength',
      submit: 'Change password and log in',
      generatePassword: 'Generate strong password',
      success: 'Password has been changed successfully',
      loginAfterChangeFailed: 'Password was changed, but automatic login failed. Please sign in with your new password.',
      sameAsTemporaryPassword: 'New password cannot be the same as your temporary password.',
      validationError: 'Please correct the password requirements before continuing.',
      invalidToken: 'Your password change session has expired. Please log in again.',
      rules: {
        minLength: 'At least 12 characters',
        uppercase: 'At least one uppercase letter',
        lowercase: 'At least one lowercase letter',
        digit: 'At least one digit',
        special: 'Special character recommended'
      }
    },
    toastMessages: {
      success: 'Operation has been accomplished with success',
      error: 'Unexpected error, please try again later.',
      invalid: 'Invalid values in form',
      done: 'Done!',
      requestProcessed: 'The request is being processed. One moment please...',
      noQuestions: 'Training must contain at least 1 question',
      pointsAdded: 'Booking made',
      selectUser: 'Select user from list',
      selectOneField: 'Select one field',
      pointRemoveSoon: 'Points will be deleted soon',
      dataLoading: 'Data is loading, please wait',
      selectDealerGroup: 'Select dealer group',
      shopStatsStartImportUser: 'Start importing: Shop Statistics - USER',
      shopStatsPrepareMissingExportToken: 'Prepare step did not return export_token.',
      shopStatsPrepareInvalidNextChunk: 'Prepare step returned invalid next_chunk.',
      shopStatsPrepareUnchangedChunkCursor: 'Prepare step returned unchanged chunk/cursor.',
      shopStatsPrepareMaxIterations: 'Prepare step exceeded maximum iterations.',
      shopStatsConvertInvalidNextSubstep: 'Convert step returned invalid next_substep.',
      shopStatsConvertMaxIterations: 'Convert step exceeded maximum iterations.',
      shopStatsExportInvalidDownloadUrl: 'Export step did not return a valid download URL.',
      shopStatsDone: 'Done',
      shopStatsExportFailed: 'Export failed'
    },
    stats: {
      users_list: 'Count of users',
      external_trainings_request: 'External Trainings',
      product_trainings_request: 'Product trainings',
      bridgestone_courses_request: 'BS Training',
      hunter_request: 'Hunter',
      investments_request: 'Investment support',
      orders_list: 'Order list',
      history_list: 'Login history',
      salespromotions_list: 'Sales promotions',
      complaints_list: 'Complaints',
      points_list: 'Points list',
      kickback_list: 'Kickback fee',
      history_hour: 'Login hours',
      tyre_list: 'Tyres'
    },
    product_trainings_request: 'Product trainings requests',
    bridgestone_courses_request: 'BS Training requests',
    attempt_number: 'Attempt number',
    thirdPartyInvoice: 'Third party invoice',
    userInvoice: 'User invoice',
    bankAccountOwner: 'Bank account owner',
    open: 'Open',
    appLogo: 'Application Logo',
    appURL: 'Application URL',
    appURLSSOLogin: 'URL after SSO login',
    url: 'URL',
    url_text: 'URL text',
    choose_posterSide: 'Image side: ',
    left: 'Left',
    right: 'Right',
    disclaimer: 'Disclaimer',
    supply: {
      history: 'Supply history',
      quantity: 'Quantity'
    },
    copyAsMain: 'Copy as main teaser',
    news_feed_slider_list: "News feed slider's list",
    usersPage: {
      boostersToApprove: 'Booster to approve',
      lastLogin: 'Last Login:',
      isPreonboarded: 'Pre-onboarded',
      isBl: 'Division Head',
      customerNumbers: 'Customer number(s)',
      branches: 'Branch(es)',
      balance: 'Account balance',
      orders: 'Orders',
      groups: 'Groups',
      notes: 'Notes',
      salesStaff: 'Sales staff',
      parentBranch: 'Parent Branch',
      childBranch: 'Subbranch',
      addWholesaler: 'Add Wholesaler',
      addBranch: 'Add Branch',
      tooltip: 'To add a branch, you must save the customer number of the parent branch',
      tooltipRmCnLocal: 'Remove local customer number',
      tooltipRmCnDB: 'Remove customer number for database',
      statement: 'Bank statement',
      bank: {
        date: 'Date',
        supplySourceReason: 'Source of supply / Reason',
        customerNumber: 'Customer Nr.',
        article: 'Article',
        brand: 'Brand',
        product: 'Product',
        type: 'Type',
        dimension: 'Dimension',
        inch: 'Inch',
        season: 'Season',
        amount: 'Amount',
        otherActions: 'Other action or cause',
        totalPoints: 'Points total',
        editPoint: 'Edit points',
        deleteManualPointConfirm: 'Are you sure you want to delete this manual points entry ({points} points, {date})?',
        loadMore: 'Load more records',
        showAll: 'Show all',
        seasons: {
          all: 'All Season',
          summer: 'Summer',
          winter: 'Winter',
          general: 'General'
        },
        advanced: 'Advanced',
        deleteUser: 'Delete User'
      },
      advanced: 'Advanced',
      deleteUser: 'Delete user',
      deleteUserConfirm: 'Are you sure you want to delete the user?',
      deleteUserSuccess: 'User has been deleted.',
      deleteUserNotFound: 'User does not exist or has already been deleted.',
      deleteUserDealerConflict:
        'Dealer cannot be deleted because it has active customer numbers. Remove related customer numbers first.',
      deleteUserError: 'Failed to delete user. Please try again.',
      generateTemporaryPassword: 'Generate temporary password',
      generateTemporaryPasswordConfirm:
        'Are you sure you want to reset the password for {user}? The current password will stop working.',
      temporaryPasswordGeneratedTitle: 'Temporary password generated',
      temporaryPasswordOneTimeWarning: 'This password is shown only once. Copy it before closing this window.',
      copyPassword: 'Copy to clipboard',
      passwordCopied: 'Copied',
      showPassword: 'Show password',
      hidePassword: 'Hide password',
      generateTemporaryPasswordForbidden: 'You do not have permission to generate a temporary password.',
      generateTemporaryPasswordNotFound: 'User does not exist.',
      passwordMismatch: 'Passwords do not match',
      deleteCustomerNumber: 'Delete customer number',
      manageSalesStaff: 'Manage sales staff',
      availableSalesStaff: 'Available sales staff',
      assignedSalesStaff: 'Assigned sales staff',
      salesStaffTransferHint:
        'Select one or more sales staff members on either side. Use the arrows to connect or disconnect them with this dealer.',
      transferSalesStaffRight: 'Connect selected sales staff',
      transferSalesStaffLeft: 'Disconnect selected sales staff',
      salesStaffSearchNoResults: 'No matching sales staff found.',
      addSalesStaff: 'Add sales staff',
      selectSalesStaffToAdd: 'Select sales staff to add',
      noSalesStaffAssigned: 'No sales staff assigned yet.',
      noSalesStaffAvailable: 'All available sales staff are already assigned.',
      addSalesStaffConfirm: 'Are you sure you want to add sales staff {salesStaff} to this dealer?',
      deleteSalesStaffConfirm: 'Are you sure you want to remove sales staff {salesStaff} from this dealer?',
      deleteAddressConfirm: 'Are you sure you want to delete this address?',
      milestones: {
        targetLabel: 'Target',
        yearLabel: 'Year',
        new: 'New',
        empty: 'No target for any year. Create a new one.',
        editTitle: 'Edit target',
        createTitle: 'Create target',
        deleteConfirm: 'Are you sure you want to delete the milestone for target {target} and year {year}?',
        targetRequiredInfo: 'Target is required for correct points calculation for the selected year.'
      },
      milestonesTab: 'Milestones',
      campaignsTab: 'Campaigns',
      dealerGroupsLabel: 'Dealer groups',
      preOnboardStatusLabel: 'Pre-Onboard Status',
      extraEmailsTab: 'Extra emails',
      customerGroupsLabel: 'Customer groups',
      customerGroupsNone: 'None',
      showDealersList: "Show dealer's list",
      staffDealersList: "Your dealer's list",
      syncSelectedDealers: 'Sync selected dealers',
      connectAllDealersFromBs: 'Connect all dealers from BS+',
      connectAllDealersConfirmTitle: 'Connect all dealers',
      connectAllDealersConfirmDescription: 'Are you sure you want to connect all dealers to this staff user?',
      disconnectAllDealersConfirmTitle: 'Disconnect all dealers',
      disconnectAllDealersConfirmDescription: 'Are you sure you want to disconnect all dealers from this staff user?',
      transferDealersToAnotherBsStaff: 'Transfer dealers to another BS Staff',
      showingCount: 'Showing {visible} / {total}',
      groupDealersSelectedCount: '{selected} selected',
      groupDealersUnselectedCount: '{unselected} not selected',
      showGroupOnly: 'Show only',
      clearGroupFilter: 'Show all groups',
      noDealersInSelectedGroups: 'No dealers in the selected groups',
      downloadConnectedDealers: 'Download connected dealers',
      showGroupFilters: 'Show group filters',
      hideGroupFilters: 'Hide group filters',
      staffDealersToolbarSync: 'Synchronization',
      staffDealersToolbarBulk: 'Bulk actions',
      staffDealersToolbarExport: 'Export',
      importDealersByEmail: 'Import dealers from Excel',
      importDealersByEmailTitle: 'Import dealers by email',
      importDealersByEmailInfo: 'Upload an Excel file (.xlsx, .xls) with email addresses in column A only.',
      importDealersByEmailHeaderInfo: 'The first row may contain the header "email".',
      importDealersByEmailEmptySheet: 'The Excel file does not contain any data.',
      importDealersByEmailEmptyColumn: 'Column A does not contain any email addresses.',
      importDealersByEmailMultipleColumns: 'The file must contain only one column with email addresses.',
      importDealersByEmailReadError: 'Could not read the Excel file.',
      importDealersByEmailValidating: 'Validating file...',
      importDealersByEmailSummaryTitle: 'Import summary',
      importDealersByEmailAlreadyConnected: 'Already connected',
      importDealersByEmailNewConnections: 'New connections',
      importDealersByEmailNotFound: 'Not found in BS+',
      importDealersByEmailInvalidEmails: 'Invalid email format',
      importDealersByEmailDuplicates: 'Duplicate emails in file',
      importDealersByEmailSyncButton: 'Connect and sync',
      importDealersByEmailNoNewConnections: 'All emails from the file are already connected.',
      importDealersByEmailShowingCount: 'Showing {shown} of {total}',
      notesHelpText: 'Must be 8-20 words long.',
      indirectAccessAlert: 'This user has restricted access because of INDIRECT client type path.',
      parentAttributesNotEnabled:
        'You cannot save parent attributes for this market. Ask a super admin to enable this feature.',
      termsConfirmed: 'Terms and Conditions Confirmed',
      privacyConfirmed: 'Privacy Policy Confirmed',
      approvedByBs: 'Approved by BS+',
      extraDocsConfirmed: 'Extra Documents for in-direct customer Confirmed',
      restrictedAccess: 'Restricted Access',
      revokeApproval: 'Revoke approval',
      approve: 'Approve',
      allowPointsCalculationConfirm:
        'Do you want to activate/deactivate points calculation for customer number {customerNumber} ({wholesaler})?',
      calculateOneCustomerNumberTitle: 'Calculate points for customer number',
      calculateOneCustomerNumberQuestion: 'Would you like to calculate data for customer number {customerNumber}?',
      calculateOneCustomerNumberWholesaler: 'Wholesaler: {wholesaler}',
      calculateOneCustomerNumberYearLabel: 'Year',
      activateCustomerNumberConfirm: 'Are you sure you want to activate customer number {customerNumber} ({wholesaler})?',
      deactivateCustomerNumberConfirm: 'Are you sure you want to deactivate customer number {customerNumber} ({wholesaler})?',
      saveCustomerNumberConfirm: 'Are you sure you want to save or update customer number {customerNumber} ({wholesaler})?',
      selectRole: 'Select Role',
      selectClientType: 'Select Client Type',
      selectWholesaler: 'Select Wholesaler',
      pointsSummary: {
        year: 'Year',
        actions: 'Actions',
        revert: 'Revert expiry',
        recalculate: 'Recalculate expiry',
        currentPoints: 'Current points',
        pointsFromCurrentYear: 'Points from current year ({year})',
        atRiskLabel: 'Points to be spent by 31.03.{year}',
        loadError: 'Could not load points summary.',
        invalidYear: 'Year must be an integer between 2000 and 3000.',
        recalculateConfirm: 'This will remove old expiry and recalculate it for year {year}. Continue?',
        revertSuccess: 'Removed entries: {count}',
        revertConfirm: 'This will remove expiry entries for year {year}. Continue?',
        recalculateSuccess: 'Recalculated. Expired points: {points}',
        recalculateNoop: 'No points to expire for this year.'
      }
    },
    recoverUser: 'Retrieve user',
    pieces_per_set: 'Packaging units',
    new: 'New',
    all: 'All',
    showAddress: 'Show address',
    showGroup: 'Show Group',
    showPoints: 'Show points',
    showKickbacks: 'Show kickback fee',
    external_sales: 'External sales',
    login_from: 'Last Login (from)',
    login_to: 'Last Login (to)',
    searchUserDownload: {
      title: 'Download search data',
      description: 'Choose the file format for your export.',
      formatCsv: 'CSV (.csv)'
    },
    check: 'Check',
    reject: 'Reject',
    reason: 'Reason',
    active_by: 'Activated by',
    sharePassword: 'Share this password with new admin',
    activeBtn: 'Activate now',
    newUserVerify: 'Verification of the new registration',
    complaintForm: {
      sections: {
        general: {
          title: 'generally',
          ordinance: 'Ordinance of the dealer',
          generalEmail: 'Your email address',
          country: 'Country',
          pickupLocation: 'Pickup location'
        },
        regulator: {
          title: 'address tire dealer - regulator'
        },
        vehicleDetails: {
          title: 'Vehicle details',
          vehicleManufacturer: 'Vehicle manufacturer',
          vehicleModelType: 'Vehicle model and type designation according to approval',
          firstRegistration: 'First registration',
          enginePower: 'Engine power (KW e.g. 150)',
          originalEquipment: 'original equipment',
          tireMilageHours: 'Tire mileage (km) / operating hours',
          milageOrHours: 'km or hours (e.g. 2000)'
        },
        tyre: {
          tireSizeExample: 'Tire size (e.g. 215/60/16)',
          speedLoadIndex: 'Speed / Load Index',
          profileDesignation: 'Profile designation inc. Specification',
          dot: 'DOT',
          truckSerialNo: 'serial no. (only for truck tires)',
          complaintReason: 'Complaint reasons',
          isTyreReplaced: 'Have the tires already been replaced?',
          ifYesTyre: 'If yes, brand of spare tires',
          clerkName: 'Name of clerk',
          complaintReasonText: 'Complaint text'
        }
      }
    },
    yesText: 'Yes',
    noText: 'No',
    tyre: 'Tyre',
    maintenance_mode_title: 'Maintenance mode',
    maintenance_mode_description:
      'Are you sure you want to continue? When enabled, the site will be temporarily unavailable to users.',
    maintenance_mode_disable_title: 'Disable maintenance mode',
    maintenance_mode_disable_description: 'Are you sure you want to continue? The site will become available to users again.',
    buttons: {
      close: 'Close',
      send: 'Send',
      validateFile: 'Validate file',
      back: 'Back',
      placeOrder: 'Binding order',
      download: 'Download',
      downloadData: 'Download data',
      downloadSearchResults: 'Download search data',
      openDownloadModal: 'Show download data modal',
      loading: 'Loading',
      approve: 'Approve',
      deleteOrder: 'Delete order',
      archive: 'Archive',
      acceptAll: 'Accept all',
      advanceSearch: 'Advanced search',
      addMenu: 'Add menu',
      setMaintenance: 'Set maintenance',
      hideMaintenance: 'Hide maintenance',
      deactivate: 'Deactivate',
      importSelected: 'Import selected',
      clearFilters: 'Clear filters',
      toSearch: 'Search',
      delete: 'Delete',
      importArticleNumbers: 'Import',
      startOver: 'Start over',
      loadMore: 'Load more',
      loadAll: 'Load all',
      allowAccessToUsers: 'Allow access to group of users'
    },
    others: 'Others',
    archive_training_title: 'Archive training',
    archive_training: 'Do you really want to archive this training?',
    delete_menu: 'Sure to delte menu item?',
    no_entries: 'No entries',
    external_url: 'External URL',
    incomplete_address: 'Address is incomplete. Please check',
    request_from: 'Request from',
    let_see_points: 'Let user see marketing points',
    let_see_kickback: 'Let user see kickback fee',
    major: 'Major',
    media_category: 'Media category',
    dragHere: 'Drop the files here ...',
    dragDropSelectFiles: "Drag 'n' drop some files here, or click to select files",
    publicFileUploadWarning:
      'Uploaded files will be publicly accessible. If any public or sensitive data is shared by mistake, the user may face serious issues. You upload files on your own responsibility.',
    uploadingFiles: 'Uploading files',
    uploadingCurrentFile: 'Current file',
    allCategories: 'All categories',
    addEmbbeded: 'Add embedded code',
    canReceivePoints: 'Can receive points',
    canUsePoints: 'Can use points',
    wholesaler_management: {
      modal: {
        description: 'What data can wholesaler see in dealer details?'
      }
    },
    personalData: 'Personal data',
    operatingData: 'Operating data',
    orderDelivery: 'Shipping address',
    diffDeliveryAddres: 'Add delivery address',
    status_iban: 'Status IBAN',
    iban: 'IBAN',
    show_export_user_iban: 'Users Dealer Iban',
    do_match: 'Change to Match',
    iban_status: {
      nameMatchResult: {
        MATCH: 'when the provided name matches the value of the account holder name held by the source',
        CLOSE_MATCH: '<b>when the provided name closely resembles the value of the account holder name held by the source</b>',
        NO_MATCH: '<b>when the provided name does not match the value of the account holder name held by the source</b>',
        COULD_NOT_MATCH: '<b>when the provided name could not be matched against the source data</b>',
        NAME_TOO_SHORT:
          '<b>when the provided name is too short to perform a match against the value of the account holder name held by the source</b>'
      },
      dataUsedForMatching: {
        VERIFIED: 'Verified is the data that exists at the beneficiary bank',
        DERIVED: '<b>Derived is data based on historical transactions</b>'
      },
      accountNumberValidation: {
        VALID: 'An account that conforms to the standards, e.g. a valid Mod97 calculation for an IBAN',
        NOT_VALID: '<b>account is an account that does not conform to the standards</b>'
      },
      paymentPreValidation: {
        PASS: 'is returned when the account identification was successfully validated to an account that can receive funds',
        WILL_FAIL: '<b>is returned if the payment will definitely fail</b>',
        WARNING:
          '<b>is returned in case the account identification was not successfully validated to an account that can receive funds, however, the responding bank is unable to provide a definitive answer</b>'
      },
      status: {
        ACTIVE: 'Account is a valid account and supported for checks',
        INACTIVE:
          '<b>Account is a valid account marked as inactive by the account holding bank, by a third party or by SurePay if SurePay has reason to believe that the account should be marked as inactive</b>',
        NOT_SUPPORTED: '<b>Account status stands for an account that is valid but is not supported to perform any checks</b>',
        NOT_FOUND:
          '<b>Account status stands for an account that is valid but could not be found in any of the connected data sources</b>',
        UNKNOWN: '<b>Account status is for an account that is either found as part of DERIVED data or a NOT_VALID account</b>'
      }
    },
    current_tyres_amount: 'Tyre amount',
    current_points: 'Score',
    current_kickbacks: 'Kick-back',
    change_role_info:
      'Changing a role in the <b>Bridgestone PLUS-System</b> deletes connections that are associated with a given role, e.g. points, customer numbers, connections between a Bridgestone processor and a dealer, orders, etc. are deleted. Are you sure you want to make this change because there is no way back?',
    firstRegistration: 'First registration',
    mediaCategories: {
      products: 'Products',
      brand_and_solutions: 'Brand & Solutions',
      season_and_promotions: 'Season & Promotions',
      format: 'Format',
      cars_and_vans: 'Cars & Vans',
      truck_and_buses: 'Trucks & Buses',
      motorcycle: 'Motorcycle',
      agriculture: 'Agriculture',
      construction_machinery: 'Construction machinery',
      bridgestone: 'Bridgestone',
      firestone: 'Firestone',
      bandag: 'Bandag',
      bleetcare: 'Fleetcare',
      webfleet: 'Webfleet',
      summer: 'Summer',
      winter: 'Winter',
      all_season: 'All Season',
      trucks: 'Trucks',
      technology: 'Technology',
      oe: 'OE',
      allSeason: 'All Season',
      season: 'Season',
      promotions: 'Promotions',
      video_in_store: 'Video (Instore)',
      video_online: 'Video (Online)',
      banner_website: 'Banner (Website)',
      banner_social_media: 'Banner (Social Media)',
      logos: 'Logos',
      b_drive: 'B-drive',
      media_library: 'Media library',
      media_packages: 'Media packages',
      video: 'Video',
      material: 'Materials',
      price_list: 'Price List',
      brochures: 'Brochures',
      price: 'Price'
    },
    deleteMediaModal: {
      title: 'Delete media collection',
      description: "Do you confirm delete file's collection? It will delete all connect files.",
      filesLabel: 'Files that will be deleted',
      noFiles: 'No files in this collection'
    },
    deleteMediaFileModal: {
      title: 'Delete file from collection',
      description: 'Do you want to you delete file from this collection?'
    },
    languages: {
      aa: 'Afar',
      ab: 'Abkhaz',
      ae: 'Avestan',
      af: 'Afrikaans',
      ak: 'Akan',
      am: 'Amharic',
      an: 'Aragonese',
      ar: 'Arabic',
      as: 'Assamese',
      av: 'Avaric',
      ay: 'Aymara',
      az: 'Azerbaijani',
      ba: 'Bashkir',
      be: 'Belarusian',
      bg: 'Bulgarian',
      bh: 'Bihari',
      bi: 'Bislama',
      bm: 'Bambara',
      bn: 'Bengali',
      bo: 'Tibetan',
      br: 'Breton',
      bs: 'Bosnian',
      ca: 'Catalan',
      ce: 'Chechen',
      ch: 'Cham',
      co: 'Corsican',
      cr: 'Cree',
      cs: 'Czech',
      cu: 'Church Slavic',
      cv: 'Chuvash',
      cy: 'Welsh',
      da: 'Danish',
      de: 'German',
      dv: 'Divehi',
      dz: 'Dzongkha',
      ee: 'Ewe',
      el: 'Greek',
      en: 'English',
      eo: 'Esperanto',
      es: 'Spanish',
      et: 'Estonian',
      eu: 'Basque',
      fa: 'Persian',
      ff: 'Fulah',
      fi: 'Finnish',
      fj: 'Fijian',
      fo: 'Faroese',
      fr: 'French',
      fy: 'Western Frisian',
      ga: 'Irish',
      gd: 'Scottish Gaelic',
      gl: 'Galician',
      gn: 'Guarani',
      gu: 'Gujarati',
      gv: 'Manx',
      ha: 'Hausa',
      he: 'Hebrew',
      hi: 'Hindi',
      ho: 'Hiri Motu',
      hr: 'Croatian',
      ht: 'Haitian Creole',
      hu: 'Hungarian',
      hy: 'Armenian',
      hz: 'Herero',
      ia: 'Interlingua',
      id: 'Indonesian',
      ie: 'Interlingue',
      ig: 'Igbo',
      ii: 'Sichuan Yi',
      ik: 'Inupiaq',
      io: 'Ido',
      is: 'Icelandic',
      it: 'Italian',
      iu: 'Inuktitut',
      ja: 'Japanese',
      jv: 'Javanese',
      ka: 'Georgian',
      kg: 'Kongo',
      ki: 'Kikuyu',
      kj: 'Kuanyama',
      kk: 'Kazakh',
      kl: 'Kalaallisut',
      km: 'Khmer',
      kn: 'Kannada',
      ko: 'Korean',
      kr: 'Kanuri',
      ks: 'Kashmiri',
      ku: 'Kurdish',
      kv: 'Komi',
      kw: 'Cornish',
      ky: 'Kyrgyz',
      la: 'Latin',
      lb: 'Luxembourgish',
      lg: 'Ganda',
      li: 'Limburgish',
      ln: 'Lingala',
      lo: 'Lao',
      lt: 'Lithuanian',
      lu: 'Luba-Katanga',
      lv: 'Latvian',
      mg: 'Malagasy',
      mh: 'Marshallese',
      mi: 'Maori',
      mk: 'Macedonian',
      ml: 'Malayalam',
      mn: 'Mongolian',
      mr: 'Marathi',
      ms: 'Malay',
      mt: 'Maltese',
      my: 'Burmese',
      na: 'Nauru',
      nb: 'Norwegian Bokmal',
      nd: 'North Ndebele',
      ne: 'Nepali',
      ng: 'Ndonga',
      nl: 'Dutch',
      nn: 'Norwegian Nynorsk',
      no: 'Norwegian',
      nr: 'South Ndebele',
      nv: 'Navajo',
      ny: 'Chichewa',
      oc: 'Occitan',
      oj: 'Ojibwa',
      om: 'Oromo',
      or: 'Odia',
      os: 'Ossetian',
      pa: 'Punjabi',
      pi: 'Pali',
      pl: 'Polish',
      ps: 'Pashto',
      pt: 'Portuguese',
      qu: 'Quechua',
      rm: 'Romansh',
      rn: 'Rundi',
      ro: 'Romanian',
      ru: 'Russian',
      rw: 'Kinyarwanda',
      sa: 'Sanskrit',
      sc: 'Sardinian',
      sd: 'Sindhi',
      se: 'Northern Sami',
      sg: 'Sango',
      si: 'Sinhala',
      sk: 'Slovak',
      sl: 'Slovenian',
      sm: 'Samoan',
      sn: 'Shona',
      so: 'Somali',
      sq: 'Albanian',
      sr: 'Serbian',
      ss: 'Swati',
      st: 'Southern Sotho',
      su: 'Sundanese',
      sv: 'Swedish',
      sw: 'Swahili',
      ta: 'Tamil',
      te: 'Telugu',
      tg: 'Tajik',
      th: 'Thai',
      ti: 'Tigrinya',
      tk: 'Turkmen',
      tl: 'Tagalog',
      tn: 'Tswana',
      to: 'Tonga',
      tr: 'Turkish',
      ts: 'Tsonga',
      tt: 'Tatar',
      tw: 'Twi',
      ty: 'Tahitian',
      ug: 'Uyghur',
      uk: 'Ukrainian',
      ur: 'Urdu',
      uz: 'Uzbek',
      ve: 'Venda',
      vi: 'Vietnamese',
      vo: 'Volapuk',
      wa: 'Walloon',
      wo: 'Wolof',
      xh: 'Xhosa',
      yi: 'Yiddish',
      yo: 'Yoruba',
      za: 'Zhuang',
      zh: 'Chinese',
      zu: 'Zulu',
      at: 'German',
      cz: 'Czech',
      'fr-FR': 'French',
      'fr-BE': 'French',
      'nl-BE': 'Dutch'
    },
    colleague: 'colleague',
    tradeInDate: 'Trade in date',
    vouchers: {
      id: 'ID',
      code: 'Code',
      colleagueName: 'Colleague name',
      dealerName: 'Dealer name',
      download: 'Download',
      points: 'Number of points per voucher',
      amount: 'Number of vouchers',
      deleteConfirmTitle: 'Delete voucher',
      deleteConfirmDescription: 'Are you sure you want to delete this voucher?'
    },
    selectText: 'Select',
    brochureCategories: {
      products: 'Products',
      brand_and_solutions: 'Brand & Solutions',
      season_and_promotions: 'Season & Promotions',
      format: 'Format',
      cars_and_vans: 'Cars & Vans',
      truck_and_buses: 'Trucks & Buses',
      motorcycle: 'Motorcycle',
      agriculture: 'Agriculture',
      construction_machinery: 'Construction Machinery',
      bridgestone: 'Bridgestone',
      firestone: 'Firestone',
      bandag: 'Bandag',
      bleetcare: 'Fleetcare',
      webfleet: 'Webfleet',
      material: 'Materials',
      brochures: 'Brochures',
      price_list: 'Price List',
      materials: 'Materials',
      summer: 'Summer',
      winter: 'Winter',
      all_season: 'All Season',
      promotions: 'Promotions',
      video_in_store: 'Video with subtitles',
      video_online: 'Video without subtitles',
      banner_website: 'Banner',
      banner_social_media: 'Social Media',
      logos: 'Logos',
      some: 'Social Media'
    },
    survey: {
      new: 'New Survey',
      edit: 'Edit Survey',
      name: 'Name',
      title: 'Title',
      description: 'Description',
      url: 'Url of Hello Customer Stand-alone Survey',
      return_url: 'Return link to insert in Hello Customer Backend',
      user_email: 'Email',
      user_first_name: 'First Name',
      user_last_name: 'Last Name',
      user_gender: 'Gender',
      user_customer_number: 'Customer Number',
      user_whs: 'Whs',
      user_zip_code: 'Zip Code',
      has_rewards: 'Reward Survey participation',
      user_information: 'Selection of user information to be transmitted to Hello Customer',
      points: 'points',
      surveys_activated: 'Activated Surveys',
      select_surveys_activated: 'Select an activated survey'
    },
    deleteMainBox: {
      title: 'Delete main box',
      description: 'Are you sure you would like to delete this item?'
    },
    apps: {
      app_new: 'New App',
      title: 'Applications',
      name: 'Name',
      code: 'Code',
      ownerName: 'Owner Name',
      ownerEmail: 'Owner Email',
      firstName: 'Firstname',
      lastName: 'Lastname',
      chooseFile: 'Choose file',
      noFileSelected: 'No file selected',
      tabDetails: 'Details',
      tabBusinessUnits: 'Business Units',
      tabLocalizedContent: 'Localized Content',
      tabOwners: 'App Owners',
      isVisibleEveryone: 'Open access',
      isSSOReady: 'SSO',
      relationDirect: 'Direct',
      relationInDirect: 'Indirect',
      clientType: 'Client type',
      clientTypeEveryone: 'Everyone',
      clientTypeDirect: 'Direct',
      clientTypeIndirect: 'Indirect',
      clientTypeDirectIndirect: 'Direct + Indirect',
      isVisibleEveryoneLabel:
        'When enabled, access is open to all users matching the visibility settings below. When disabled, access is restricted and must be granted manually per user in the user profile or via user list upload.',
      visibilityWhitelistHint: 'Visibility is controlled only via the user list (App Users). Context Permission is not used.',
      isSSOReadyLabel: 'Is SSO ready?',
      relationDirectLabel: 'Direct customers',
      relationInDirectLabel: 'Indirect customers',
      removeOwner: 'Remove',
      addNextOwner: 'Add Next Owner',
      saveOwners: 'Save Owners',
      local_app: 'Local',
      managed_globally_info: 'This application is managed by the Global Admin',
      managed_globally_disabled: 'The Global Admin has disabled this application for your country',
      app_alert: {
        title: 'Confirm',
        desc: 'Are you sure you want to remove this local application?'
      },
      app_change_state_alert: {
        title: 'Confirm',
        desc: 'This application is managed by global admin. Do you want to change running status of this app?'
      }
    },
    campaigns: {
      title: 'Campaigns',
      new: 'New Campaign',
      edit: 'Edit campaign',
      name: 'Campaign Name',
      subtitle: 'Campaign Subtitle (optional)',
      description: 'Description',
      type: 'Campaign type',
      selectType: 'Select campaign type',
      periodName: 'Period Name',
      startDate: 'Start date',
      endDate: 'End date',
      newPeriod: 'New period',
      image: 'Picture',
      url: 'Url',
      active: 'Active',
      types: {
        'performance-speedy': 'Performance',
        'performance-cd': 'Performance CD',
        'booster-ccs': 'Booster CCS'
      },
      transferDealersModal: {
        openButton: 'Transfer dealers to another campaign',
        title: 'Select campaign',
        description: 'You can transfer dealers from current campaign: {campaignName} to another.',
        loadingCampaigns: 'Loading campaigns...',
        selectCampaignPlaceholder: 'Select campaign',
        submit: 'Send request',
        sending: 'Sending...',
        requestSent: 'Request sent',
        requestFailed: 'Failed to send request'
      },
      alert: {
        title: 'Confirm',
        desc: 'Are you sure you want to remove this campaign?'
      }
    },

    bsPlus: {
      buttons: {
        appButtons: {
          pending: 'Pending',
          open: 'Open',
          requestAccess: 'Request access'
        }
      },
      homepage: {
        my: 'Apps',
        titleColorRev: 'false',
        welcomeMessage: "Welcome to BRIDGESTONE <span class='text-danger'>PLUS</span>, %{first_name} %{last_name}",
        showProfile: 'Show Profile',
        newMessages: 'New messages in your inbox',
        directRoute: 'Your direct route to all Bridgestone web applications.',
        myAppsDescription: 'all Bridgestone web applications for which you are already a member',
        allAppsDescription: 'All Apps - All the Bridgestone web applications that may be of interest to you.',
        home: 'Home',
        search: 'Search',
        sortBy: 'Sort by',
        myApps: 'My Apps',
        allApps: 'All Apps',
        inbox: 'Inbox',
        profile: 'Profile',
        seeMore: 'See more',
        showMessages: 'Show messages'
      },
      myProfile: {
        welcomeMessage: 'Welcome to your personal area. Here, you can update or adjust your master data and view your inbox.',
        masterData: 'Master Data',
        completeDetails: 'Complete your personal and company details for a successful registration.',
        goToMasterData: 'Go to Master Data',
        goToInbox: 'Go to inbox'
      },
      masterData: {
        welcomeMessage: 'Welcome to your personal area. Here you can update or adjust your master data.',
        personalDetails: 'Personal details',
        companyDetails: 'Company details',
        emailAddress: 'Email address',
        title: 'Title',
        surname: 'Surname',
        firstName: 'First name',
        jobPosition: 'Job position',
        streetAndHouseNumber: 'Street & house number',
        postalCode: 'Postal code',
        city: 'City',
        country: 'Country',
        legalStructure: 'Legal structure',
        customerNumber: 'Customer number',
        importantPleaseRead: 'Important please read',
        customerNumberInfo:
          'To properly assign your tire orders to wholesalers and/or Bridgestone, it is essential that you provide your respective customer numbers.',
        multipleCustomerNumbers:
          'If you have multiple customer numbers with a wholesaler and/or Bridgestone, for example, for your main business and your branches, please provide the customer number for the main business first.',
        salesAssignment: 'The sales associated with the additional customer numbers will then be assigned to your main business.',
        supplier: 'Supplier',
        addAnotherCustomerNumber: 'Add another Bridgestone customer number',
        save: 'Save',
        delete: 'Delete'
      },
      inbox: {
        welcomeMessage: 'Here you can find important notifications and news.',
        sender: 'Sender',
        subject: 'Subject',
        date: 'Date',
        formConsulting: 'Form Consulting - Thank you for processing the form',
        back: 'Back'
      },
      legalAndContact: {
        cookieSettings: 'Cookie-settings',
        dataPolicy: 'Data policy',
        termsOfUse: 'Terms of use',
        helpAndContact: 'Help and contact'
      },
      logInSignUp: {
        logIn: 'Log in',
        signUp: 'Sign up',
        logInMessage: 'Log in with your email address and password.',
        signUpMessage: 'If you are a new user, please register.'
      },
      onboarding: {
        tradingPartner: 'I am a trading partner that is',
        termsAndConditions: 'Terms and Conditions',
        accept: 'Accept',
        decline: 'Decline',
        scrollToAccept: 'Please scroll down for accepting our conditions to continue',
        welcomeMessage: 'Welcome to Bridgestone Plus',
        dataModal:
          'In order to be able to adapt this offer to your needs, we ask you to kindly identify yourself and indicate your interests in terms of products or sectors of activity.',
        tailorOffer:
          'In order to be able to tailor this offer to your interests, we would ask you to briefly state your product interests or business areas.',
        selectAreas: 'Please select* from the following areas',
        multipleAnswers: '(multiple answers possible)',
        personalPreferences: 'Personal Preferences',
        carTyres: 'Car tyres, SUV, utility',
        motorcyclesTyres: 'Motorcycles tyres',
        truckBusTyres: 'Truck and bus tyres',
        agricultureTyres: 'Tyres for agricultural vehicles',
        otrTyres: 'OTR tyres',
        save: 'Save',
        businessRelationship: 'What is your business relationship with Bridgestone?',
        selectRelationship: 'Please select* from the following areas',
        tradingPartnerDirect: '... directly ordering from Bridgestone',
        tradingPartnerIndirect: '... indirectly ordering (via wholesale e.g.)',
        tradingPartnerBoth: '... both directly and indirectly ordering',
        fleetResponsibleDirect: 'I am a fleet responsible that is... directly ordering from Bridgestone',
        fleetResponsibleIndirect: '... indirectly ordering (via trade or wholesale)',
        fleetResponsibleBoth: '... directly and indirectly ordering',
        noBusinessRelationship: 'I have no business relationship with Bridgestone (neither directly nor indirectly)',
        yourCustomerNumber: 'Your Bridgestone customer number*: ',
        enterCustomerNumber: 'Enter your customer number',
        waitPersonalisedView: 'Please wait a moment, your personalised view of BRIDGESTONE PLUS will be generated.',
        personalised: 'Personalised',
        plusInfo: 'Here you will find information about your Plus account and your Plus mailbox.',
        continue: 'Continue',
        skip: 'Skip',
        oneOfTwo: '1 of 2',
        openApps:
          'You can directly open the apps you are already registered for. You can also request access to other apps that may be relevant to you.',
        requiredFields: 'Fill in the required fields: Title, First name, Last name',
        stage: 'Part'
      }
    },
    anyLogin: 'Show users with login only',
    frontend_menu: {
      account: 'Profile',
      plus: 'About Bridgestone Plus',
      salesSupport: 'Sales support',
      mailbox: 'Mailbox',
      about: 'About Bridgestone Plus',
      trainingAndCourses: 'Online tranings',
      externalTraining: 'External trainings',
      productInfo: 'Product informations',
      productBrochures: 'Brochures',
      priceLists: 'Price list',
      price: 'Price',
      complaintForm: 'Complaint form',
      sales_support: 'Sale support',
      contact_service: 'Contact & Service',
      logOut: 'Logout',
      news: 'News feeds',
      news_feeds: 'News feeds',
      service_number: 'Contact & Service',
      brochure_prices: 'Brochures and Price list',
      trainings: 'Trainings',
      salesPromotions: 'Sales promotions',
      stammdaten: 'My Profile',
      onlineTrainings: 'Online Trainings',
      shop: 'Shop',
      preislisten: 'Price list',
      medias: 'Media',
      media: 'Media',
      manageLinks: 'Manage menu links',
      noModuleLinksAvailable: 'No module links available for this tenant.'
    },
    deleteBrochureFileModal: {
      title: 'Delete file from collection',
      description: 'Do you want to delete the file "{fileName}" from this collection?',
      fileNameFallback: 'Unknown file'
    },
    deleteBrochureModal: {
      title: 'Delete brochure',
      description: 'Are you sure you want to delete brochure "{name}"?',
      nameFallback: 'Unknown brochure',
      filesLabel: 'Files that will be deleted',
      noFiles: 'No files in this brochure'
    },
    fileType: {
      label: 'File type',
      video: 'Video',
      image: 'Image',
      embeded: 'Embeded',
      pdf: 'Pdf'
    },
    booster_name: 'Name',
    booster_from: 'Date from',
    booster_to: 'Date to',
    boosterList: {
      seasons: 'Seasons',
      usersAmount: "User's amount",
      factor: 'Factor',
      calculateBoosters: 'Calculate boosters',
      calculateBoostersConfirmTitle: 'Calculate boosters?',
      calculateBoostersConfirm:
        'This will start calculating booster points for matching users based on this booster configuration. The process may take some time. Results will appear in the booster preview, where you can review and accept them or delete the calculated points. After calculation is completed, editing this booster may no longer be possible. Do you want to continue?',
      showAll: 'Show all (+{count})',
      showLess: 'Show less'
    },
    product_sync: {
      lowPriceWarning:
        'Please note that the current price at external supplier is: {0} Euro ({1} points) <br> (Points / Price set up below could result in higher costs)',
      syncEnabled: 'Sync Enabled',
      syncDisabled: 'Sync Disabled',
      syncDisable: 'Update via API',
      syncEnable: 'Manual product update',
      notAvailableDisable: 'Not visible in the shop',
      notAvailableEnable: 'Visible in the shop',
      notAvailableDisabled: 'Not visible in the shop',
      notAvailableEnabled: 'Visible in the shop',
      notAvailableError: 'Not Available Error',
      syncError: 'Sync Error',
      tooltip: {
        syncEnable:
          'Please note that the manual product update is limited to price/point management only. All other product-related information will be updated via API and cannot be modified by the local admin.',
        notAvailableEnable: 'Mark product as not available for this market.',
        notAvailableDisable: 'Make product available again for this market.'
      }
    },
    category_sync: {
      syncEnabled: 'Image sync enabled',
      syncDisabled: 'Image sync disabled',
      syncDisable: 'Update image via API',
      syncEnable: 'Manual image update',
      syncError: 'Image sync error',
      tooltip: {
        syncEnable:
          'Disabling sync only affects the category image. Name, description and status still come from the global catalog. While image sync is enabled, the image is taken from the global catalog and cannot be changed locally.'
      }
    },
    priceCategories: {
      pkw: 'Pkw, 4x4 and Transporter',
      motorcycles: 'Motorcycles',
      trucksAndBuses: 'Trucks And Buses',
      agriculture: 'Agriculture',
      constructionMachineryOtr: 'Construction Machinery Otr'
    },
    customerNumbersAssistant: {
      date: {
        title: 'Calculate points starting from date X',
        warning: 'Main business numbers cannot be changed based on a selected date!'
      },
      import: {
        openButton: 'Import customer numbers',
        loadingModal: 'Loading modal...',
        title: 'Import customer numbers from Excel',
        validateButton: 'Validate file',
        submitButton: 'Send to API',
        submitButtonLoading: 'Sending...',
        selectWholesalerLabel: 'Wholesaler',
        selectGroupLabel: 'Group',
        selectWholesalerPlaceholder: 'Select wholesaler',
        selectGroupPlaceholder: 'Select group (optional)',
        requirementsTitle: 'File requirements',
        fileFormatRequirement: 'Excel file only: .xlsx or .xls',
        headerRequirement: 'Header row must be: Customer number, Email (A/B columns).',
        createdLabel: 'Created',
        alreadyExistsLabel: 'Already exists',
        success: 'Excel file is valid.',
        previewTitle: 'Preview',
        previewCount: '{count} rows, {pageSize} rows per page.',
        columnOne: 'Column 1',
        columnTwo: 'Column 2',
        previousPage: 'Previous',
        nextPage: 'Next',
        pageInfo: 'Page {current} / {total}',
        progressLabel: 'Progress',
        errors: {
          wholesalerRequired: 'Wholesaler is required.',
          groupRequired: 'Group is required.',
          fileRequired: 'Excel file is required.',
          emptyWorkbook: 'Excel workbook is empty.',
          invalidHeaders: 'File must contain exactly 2 columns: customer number and email.',
          emptyRows: 'File does not contain any data rows.',
          firstTwoColumnsRequired: 'Row {row}: first and second column must be filled.',
          invalidCustomerNumber: 'Invalid customer number in row {row}. Use only letters and digits.',
          invalidEmail: 'Invalid email in row {row}.',
          invalidFileType: 'Only Excel files (.xlsx, .xls) are allowed.',
          readError: 'Could not read Excel file.',
          submitFailed: 'Failed to send records to API.'
        }
      }
    },
    'points-importer': {
      new: 'New import',
      title: 'Point importer',
      label: 'File with points',
      undo: 'Reset ({points} points)',
      undo_less: 'Reset',
      repair_invalid_entries: 'Repair invalid entries ({points} points)',
      recalculate: 'Recalculate ({points} points)',
      abort: 'Abort',
      upload: 'Upload ({points} points)',
      downloadSelected: 'Download selected entries',
      addRow: 'Add row',
      'select-year': 'Select import year',
      'importer-type': 'Import type',
      'import-name': 'Import name',
      'switch-point-type': 'File upload / Manual input',
      progress: {
        upload: 'Upload',
        repairing: 'Repairing invalid entries',
        calculating: 'Calculating',
        validating: 'Validating',
        loading: 'Loading import data'
      },
      configurableFields: {
        skipRows: 'Skip rows',
        headerRow: 'Header row',
        firstData: 'First row with data',
        Quantity: 'Quantity',
        Rim: 'Rim',
        Brand: 'Brand',
        IPC: 'IPC',
        Date: 'Date',
        CustomerNumber: 'CustomerNumber'
      },
      historyStatus: {
        failed: 'Calculation aborted',
        pending: 'Not calculated yet',
        completed: 'Calculated',
        calculated: 'Calculated (Validation pending)',
        invalid_points: 'Invalid calculation'
      },
      table: {
        index: '',
        customerNumber: 'Customer number',
        pointsInList: 'Already existing points',
        user: 'Dealer ID',
        points: 'Points from file',
        adds: 'New points',
        added: 'Added points',
        actions: 'Actions'
      },
      item: {
        customer_number: 'Customer number',
        brand: 'Brand',
        rim: 'Rim',
        quantity: 'Quantity',
        dealer_id: 'Dealer ID',
        points_pending: 'New points',
        points_completed: 'Calculated points',
        points_invalid_points: 'Designated points',
        status: 'Status',
        imported_points: 'Imported points',
        actions: 'Actions'
      },
      itemStatus: {
        pending: 'Pending',
        merged: 'Already imported',
        calculating: 'Calculation pending',
        calculated: 'Calculated'
      },
      alert: {
        success: 'Points successfully imported'
      },
      details: {
        reset: {
          title: 'Reset all points',
          question: 'Do you really want to reset all points? The points can be recalculated afterwards.'
        }
      },
      'details-modal': {
        title: 'Import details',
        error: {
          header: {
            message: 'Message',
            data: 'Data',
            attribute: 'Attribute',
            value: 'Value'
          }
        },
        data: {
          brand: 'Brand',
          rim: 'Rim',
          quantity: 'Quantity',
          points: 'Points',
          points_per_item: '{points} Points / Item',
          customer_number: 'Customer number'
        }
      },
      list: {
        header: {
          points: 'Points',
          historyStatus: 'State'
        },
        deleteImport: 'Delete import',
        deleteImportConfirm: 'Are you sure you want to delete this import?'
      },
      show: {
        header: {
          importer_points: 'Importer points',
          actual_points: 'Already imported points',
          expected_points: 'Points after import',
          imported_points: 'Imported points',
          delta_points: 'Difference'
        }
      },
      settings: {
        title: 'Importer settings',
        mode: 'Mode',
        modes: {
          merge: 'Merge',
          addition: 'Addition',
          direct: 'Direct point import without Adex'
        },
        skipRows: 'Skip rows',
        headerRow: 'Header row',
        firstRow: 'First row with data',
        allData: 'Import data without dealers',
        workSheet: 'Worksheet',
        columnSet: 'Column set: {type}',
        columns: 'Columns',
        columnConfiguration: 'Column configuration',
        columnData: {
          title: 'Column configuration / processing:',
          description:
            'To ensure the importer works, we use any available or unused cell to overwrite it with data, for example, if the brand is not specified.'
        },
        parseColumnData: {
          title: 'Parse columns by pattern:',
          description:
            'Example: <code>R(\\d{2})</code> searches for R00 - R99 in a string and returns the number. This allows us to read the rim size.'
        },
        replaceColumnData: {
          title: 'Replace column with:',
          description:
            'In some cells, for example, <code>Bridgestone</code> needs to be converted to <code>bs</code> before import.'
        }
      }
    },
    'points-importer-types': {
      list: {
        table: {
          name: 'Name',
          description: 'Description'
        }
      }
    },
    marketingConsents: {
      pageTitle: 'Marketing Consents',
      title: 'Title',
      status: 'Status',
      noConsents: 'No marketing consents available',
      enabled: 'Enabled',
      disabled: 'Disabled',
      enable: 'Enable',
      disable: 'Disable',
      enableTitle: 'Enable Marketing Consent',
      enableMessage: 'Are you sure you want to enable this marketing consent?',
      disableTitle: 'Disable Marketing Consent',
      disableMessage: 'Are you sure you want to disable this marketing consent?',
      toggleSuccess: 'Marketing consent status has been updated successfully',
      toggleError: 'An error occurred while updating the marketing consent',
      consentType: 'Consent Type',
      selectType: 'Select type...',
      typeChanged: 'Consent type updated successfully',
      typeChangeError: 'Failed to update consent type',
      visibleFrom: 'Visible from',
      notYetVisible: 'Not yet visible',
      alwaysVisible: 'Always visible'
    }
  },
  wholesaler_management: {
    modal: {
      description: 'What data can wholesaler see in dealer details?'
    }
  }
}
